import { useCommunityId } from '@/hooks/communities';
import { useCommunityPhotos } from '@/hooks/community-photos';
import GalleryPage from '@/pages/GalleryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/gallery')({
  component: GalleryPage,
  loader: async ({ context: { queryClient } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    if (data?.communityId) {
      await useCommunityPhotos.ensureQueryData(queryClient, [data.communityId]);
    }
  },
});
